export class ErrorModel {
  code: string = '99';
  message: string = '';
  rawError: any;
  constructor(error?) {
    if(error) {
      this.code = error.code || '0';
      this.code = error.code || '0';
      this.message = error.message || '';
      this.rawError = error || null;
    }
    return this;
  }
   withCode(code: string) {
      this.code = code;
      return this;
    }

    getCode() {
      return this.code;
    }
    getCodeNumber() {
      return parseInt(this.code);
    }
    withMessage(message: string) {
      this.message = message;
      return this;
    }
    getMessage() {
      return this.message;
    }
    withRaw(error: any) {
      this.rawError = error;
      return this;
    }

    getRaw(): any {
      return this.rawError;
    }
}
